import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import CardContainer from "./CardContainer";
import { apiFetch } from "../api"; 
import { toast } from "react-hot-toast";
import { Spinner, ProgressBar } from "react-bootstrap";

const SimpleCards = ({ searchQuery, onProductClick }) => {
  const [loading, setLoading] = useState(false);
  const [posts, setPosts] = useState([]);
  const [error, setError] = useState(null);
  const [searchParams] = useSearchParams();
  const categoryFilter = searchParams.get('category');

  async function fetchProductData() {
    setLoading(true);
    // ---FIX--- Check for a token before making the API call
    const token = localStorage.getItem('token');
    // if (!token) {
    //     // If no token, don't try to fetch. Set posts to empty and stop loading.
    //     setPosts([]);
    //     setLoading(false);
    //     return;
    // }

    try {
      const data = await apiFetch("/api/products/all");
      if (data.success && data.data) {
        setPosts(data.data);
      } else {
        setPosts([]);
      }
    } catch (error) {
      toast.error(`Could not load products: ${error.message}`);
      setPosts([]);
    }
    setLoading(false);
  }

  useEffect(() => {
    fetchProductData();
  }, []);

  // Filter posts based on searchQuery
  const normalizeString = (str) => str ? str.split(' ').join('').toLowerCase() : '';
  const trimmedQuery = searchQuery ? searchQuery.trim() : '';
  const searchFilteredPosts = trimmedQuery ? posts.filter(post => normalizeString(post.name).includes(normalizeString(trimmedQuery))) : posts;

  // Filter posts based on category if present
  const categoryFilteredPosts = categoryFilter ? searchFilteredPosts.filter(post => post.category && post.category.name === categoryFilter) : searchFilteredPosts;

  // Group by category
  const groupedPosts = categoryFilteredPosts.reduce((acc, post) => {
    const category = post.category && post.category.name ? post.category.name : 'Uncategorized';
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(post);
    return acc;
  }, {});

  return (
    <>
      {loading ? (
        <div className="text-center py-5 w-100">
          <div className="text-center">
            <Spinner animation="border" className="loading-spinner" style={{ color: "#82278A", width: '3rem', height: '3rem' }} />
            <div className="mt-3">
              <p className="text-purple mb-2">Loading products...</p>
              <ProgressBar 
                now={100} 
                animated 
                style={{ height: '4px', width: '200px', margin: '0 auto' }}
                variant="purple"
              />
            </div>
          </div>
        </div>
      ) : error ? (
        <div style={{ textAlign: 'center', marginTop: '50px', fontSize: '18px', color: '#d9534f' }}>
          Error: {error}
        </div>
      ) : categoryFilteredPosts.length === 0 ? (
        <div style={{ textAlign: 'center', marginTop: '50px', fontSize: '18px', color: '#555' }}>
          No items found
        </div>
      ) : (
        Object.keys(groupedPosts).map(category => (
          <CardContainer key={category} posts={groupedPosts[category]} loading={loading} title={category} onClick={onProductClick} />
        ))
      )}
    </>
  );
};

export default SimpleCards;